/**
 * Red review-period message shown under the listening section instruction title.
 * Section prev/next controls are rendered in the page footer (SimulationChunkNavigation).
 *
 * @module ReviewPeriodNotice
 */

interface ReviewPeriodNoticeProps {
  readonly message: string;
}

export function ReviewPeriodNotice({ message }: ReviewPeriodNoticeProps) {
  return (
    <div className="text-center font-ui text-sm text-exam-timer-danger font-medium">
      {message}
    </div>
  );
}
